import { createGlobalStyle } from "styled-components";
import { media, rgba, p3 } from "./stylesTheme";

export const GlobalStyle = createGlobalStyle`
    /* Font faces are loaded via /fonts.css in index.html */

    :root {
        --normal: 'Font', -apple-system, sans-serif;
        --med: 'Font Med', -apple-system, sans-serif;
        --bold: 'Font Bold', -apple-system, sans-serif;
        --brm: 1.5;
    }

    @supports (corner-shape: squircle) {
        :root {
            --brm: 2;
        }
    }

    * {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
        //box-sizing: border-box;
    }

    body {
        font-family: 'Font', -apple-system, sans-serif;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        padding: 0;
        margin: 0 !important;
        min-height: 100svh;
        overflow: hidden;
        overscroll-behavior: none;
        font-size: 98%;
        background: linear-gradient(111deg, ${({ theme }) =>
            rgba(theme, "gradL", 1)} 0%, ${({ theme }) =>
    rgba(theme, "gradR", 1)} 100%);
        background: linear-gradient(111deg, ${({ theme }) =>
            p3(theme, "pgradL", 1)} 0%, ${({ theme }) =>
    p3(theme, "pgradR", 1)} 100%);
    }

    button, a, input, textarea, select, [tabindex] {
        outline: none !important;
        -webkit-tap-highlight-color: transparent !important;
    }

    .no-scrollbar::-webkit-scrollbar {
        display: none;
    }
    .no-scrollbar {
        scrollbar-width: none;
    }

    ${media.respond4} {
        body { font-size: 85%; }
    }
    ${media.respond3} {
        body { font-size: 75%; }
    }
    ${media.respond2} {
        body { font-size: 71%; }
    }
    ${media.portrait} {
        body { font-size: 88%; }
    }
    ${media.mobile} {
        body { font-size: 64%; }
    }

    main {
        width: 100%;
        height: 100svh;
        margin: 0px auto;
        padding: 0px;
        line-height: 1.7em;
        overflow-y: scroll;
        overflow-x: hidden;
        overscroll-behavior: none;
        max-width: 130em;
        position: relative;

        ::-webkit-scrollbar {
            display: none;
        }
        scrollbar-width: none;
    }
`;
